export default __webpack_public_path__ + "static/media/Kapok Cushion.708bc3ae.jpg";